import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RateAvailComponent } from './rate-avail.component';
import { RateAvailRoutingModule } from './rate-avail-routing.module';
import { RvReportModule } from './rv-report/rv-report.module';
import { InteractiveReportModule } from './interactive-report/interactive-report.module';

@NgModule({
  imports: [
    CommonModule,
    RateAvailRoutingModule,
    RvReportModule,
    InteractiveReportModule
  ],
  declarations: [RateAvailComponent],
  exports: [RateAvailComponent]
})
export class RateAvailModule { }
